<template>
  <v-timeline dense align-top>
    <v-timeline-item
      small
      v-for="(item, i) in activities"
      :key="i"
      :icon="getActivityTypeIcon(item.type)"
      color="lighttext"
      icon-color="white"
    >
      <template v-slot:icon>
        <v-icon v-if="getActivityTypeIcon(item.type)" x-small color="white">
          {{ getActivityTypeIcon(item.type) }}
        </v-icon>
        <avatar
          v-else-if="
            item.type == $enums.activityTypes.CREATED && type != 'CoreValue'
          "
          :avatarUrl="item.avatarUrl"
          :name="item.avatarName"
        >
        </avatar>
      </template>
      <v-row>
        <v-col cols="auto">
          <div>{{ item.text }}</div>
          <v-btn
            icon
            v-if="item.teamId != null"
            :to="is_manager ? '' : '/departments/' + item.teamId"
          >
            <team-avatar
              :team="{ name: item.avatarName, logoUrl: item.avatarUrl }"
              :color="item.avatarColor"
              cssClass="mr-1 elevation-5"
            >
            </team-avatar>
          </v-btn>
          <v-btn
            icon
            v-if="item.userId != null"
            :to="is_manager ? '' : '/members/' + item.userId"
          >
            <user-avatar
              :user="{ fullName: item.avatarName, avatarUrl: item.avatarUrl }"
              cssClass="mr-1 elevation-5"
            ></user-avatar>
          </v-btn>
          <v-btn
            v-if="item.surveyId"
            outlined
            color="secondary"
            rounded
            class="mt-1"
            :to="'/reporting/surveys/overview/surveys/' + item.surveyId"
          >
            View Results
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="text-right">
          <strong>{{ item.date | longDate }}</strong>
          <div>
            {{ item.date | time }}
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { mapGetters } from "vuex";
import activityTypes from "@/helpers/mixins/activityTypes";
export default {
  name: "ActivityTimeline",
  components: {},
  mixins: [activityTypes],
  props: { activities: { type: Array }, type: { type: String, default: "" } },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapGetters({ is_manager: "profile/is_manager" })
  },
  created() {},
  methods: {}
};
</script>
